var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"btn",staticClass:"btn role-primary",on:{"click":_vm.login}},[_vm._v("\n  Log In with GitHub\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }